export const ThirthSectionData = {
 pengetahuanUmum: [
   "Pengetahuan Barber",
   "Pengetahuan Alat Tukang Cukur",
   "Layanan Dasar"
 ],

 materiTeori: [
   "Kepala dan Rambut",
   "Teori Fade",
   "Bagian dan Perpisahan",
   "Kepala Bagian",
   "Gaya Rambut",
   "Pekerjaan Gunting dan Clipper",
   "Cukur"
 ],

 simulasi: [
   "Pemotonggan Panjang & Bob",
   "Pekerjaan Sisir",
   "Pekerjaan Jaan Clipper",
   "Pekerjaan Jaan Gunting",
   "Penataan rambut",
   "Gradasi",
   "Potongan Rambut Panjang Atas",
   "Pangkas dan Cukur"
 ],

 praktek: [
   "Penyadap Dasar",
   "Luntur",
   "Potongan Rambut Panjang Atas",
   "Finishing Styling",
   "Percepatan",
   "Cukur"
 ],

 layananEkstra: [
   "Cuci Rambut dan Pijat"
 ],

 softSkill: [
   "Sikap Barbering",
   "Kemampuan berkomunikasi",
   "Dasar Pemangkas Rambut",
   "Keugunaan layanan"
  ],
 
  note: [
    "Program ini sudah berstandard internasional",
    "Dilengkapi dengan kuis dan tugas setiap harinya untuk memaksimalkan proses pembelajaran",
    "Terdapat ujian pada saat pembelajaran untuk membantu mengukur sampai dimana penguasaan materi yang diajarkan",
    "Metode pembelajaran yang efisien dan telah diujicoba"
 ],
 
}